module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm_title"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I owe a debt of gratitude to the following:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Lord Sandhurst, for access to his father’s records of the Radio Security Service and Special Communications Unit 1; Jürgen Rohwer; Donald Shirreff; Ralph Erskine; Roy Rodwell of the Marconi Company; Barbara Tuchman; David Kahn; Pat Hawker; Gerry Openshaw; all the former members of RSS who kindly gave their help; and the Radio Society of Great Britain.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The staff of the Public Records Office in Kew; the British Museum; the Imperial War Museum; Churchill College, Cambridge; King’s College, London; the GPO Archives, London; the Royal Signals Museum, Blandford; the Intelligence Corps Museum, Ashford.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11835881","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 69
// module chunks = 0